module.exports = __webpack_public_path__ + "static/media/digitalagency-freelancer-hero-image-horizontal.a221df23.webp";